import { useCallback, useEffect, useRef } from 'react';
import { API } from './model';

const OUTBOX = 'eb_funnel_outbox_v1';
const read = () => {
  try { const stored = JSON.parse(localStorage.getItem(OUTBOX)); return Array.isArray(stored) ? stored.filter((item) => item?.event_id && item?.session_id).slice(-80) : []; }
  catch (_) { return []; }
};

export const useFunnel = (sessionId) => {
  const pending = useRef(null);
  if (pending.current === null) pending.current = read();
  const working = useRef(false);
  const counter = useRef(0);
  const persist = useCallback(() => {
    try { localStorage.setItem(OUTBOX, JSON.stringify(pending.current)); } catch (_) { /* File mémoire en secours. */ }
  }, []);
  const flush = useCallback(async () => {
    if (working.current) return;
    working.current = true;
    try {
      while (pending.current.length) {
        const item = pending.current[0];
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        let response;
        try { response = await fetch(`${API}/api/funnel/events`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
          signal: controller.signal, body: JSON.stringify(item),
        }); } finally { clearTimeout(timer); }
        if (!response.ok && response.status !== 422) break;
        pending.current = pending.current.filter((event) => event.event_id !== item.event_id); persist();
      }
    } catch (_) { /* Réessai en ligne ou au prochain chargement, sans bloquer le devis. */ }
    finally { working.current = false; }
  }, [persist]);
  useEffect(() => {
    const leave = () => {
      persist();
      // Le serveur déduplique les beacons et les éventuelles reprises après rechargement.
      for (const item of pending.current.slice(-20)) navigator.sendBeacon?.(`${API}/api/funnel/events`, new Blob([JSON.stringify(item)], { type: 'application/json' }));
    };
    flush();
    const timer = setInterval(flush, 5000);
    window.addEventListener('online', flush); window.addEventListener('pagehide', leave);
    return () => { clearInterval(timer); window.removeEventListener('online', flush); window.removeEventListener('pagehide', leave); };
  }, [flush, persist]);
  return useCallback((event, step, values = {}) => {
    // Liste fermée : aucun nom, adresse, e-mail ou téléphone dans la mesure ni sa file locale.
    const data = {};
    if (typeof values.total === 'number' && Number.isFinite(values.total)) data.total = values.total;
    if (typeof values.code === 'string') data.code = values.code;
    if (Number.isInteger(values.days)) data.days = values.days;
    window.parent.postMessage({ type: 'eb-funnel', event, step, data }, '*');
    pending.current.push({ session_id: sessionId, event_id: crypto.randomUUID(), sequence: Date.now() * 1000 + (counter.current++ % 1000), event, step, data });
    pending.current = pending.current.slice(-80); persist(); flush();
  }, [sessionId, persist, flush]);
};